import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-457eda3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-switch" }
const _hoisted_2 = ["disabled", "checked"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'toggleSwitch',
  props: {
  /** The state of button */
  isChecked: {
    type: Boolean,
    required: false,
  },
  color: {
    type: String,
    required: false,
    default: "green",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:isChecked"],
  setup(__props, { emit }) {

const props = __props;



const checkedRef = ref(props.isChecked);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkedRef).value = $event)),
      disabled: __props.disabled,
      type: "checkbox",
      class: "input",
      checked: __props.isChecked,
      onChange: _cache[1] || (_cache[1] = () => emit('update:isChecked', checkedRef.value))
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, checkedRef.value]
    ]),
    _createElementVNode("span", {
      class: "switch",
      style: _normalizeStyle(`--color: ${__props.color}`)
    }, null, 4)
  ]))
}
}

})